import { useLanguage } from "@/i18n/LanguageContext";

export default function WhyUsSection() {
  const { t } = useLanguage();

  const reasons = [
    {
      description: t("home.why1Desc") as string,
      icon: "ri-money-dollar-circle-line",
      title: t("home.why1Title") as string,
    },
    {
      description: t("home.why2Desc") as string,
      icon: "ri-time-line",
      title: t("home.why2Title") as string,
    },
    {
      description: t("home.why3Desc") as string,
      icon: "ri-shield-check-line",
      title: t("home.why3Title") as string,
    },
    {
      description: t("home.why4Desc") as string,
      icon: "ri-hand-heart-line",
      title: t("home.why4Title") as string,
    },
  ];

  return (
    <section className="w-full bg-secondary py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-3">
            {t("home.whyTitle")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((r) => (
            <div key={r.title} className="text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-primary rounded-full mx-auto mb-4">
                <i className={`${r.icon} text-2xl text-white`} />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2">
                {r.title}
              </h3>
              <p className="text-sm text-[#fefce8] leading-relaxed max-w-xs mx-auto">
                {r.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}